import { CustomFieldsDataResolver } from '@b2b/common/resolvers';
import uiRouter, { StateParams, StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { SettingsTerminalControllerModule } from './controllers/SettingsTerminalsController';

export const SettingsTerminalsView = angular
  .module('acme.view.application.settings.terminals', [uiRouter, 'ui.bootstrap', SettingsTerminalControllerModule])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.settings.terminals',
      url: '/terminals',
      params: {
        terminalId: '',
      },
      views: {
        'subview-main': {
          controller: 'SettingsTerminalsController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/settings/terminals/terminals.tpl.html',
        },
      },
      resolve: {
        terminalId: [
          '$stateParams',
          function ($stateParams: StateParams) {
            return $stateParams.terminalId || '';
          },
        ],
        CustomFieldsData: CustomFieldsDataResolver(),
      },
      data: {
        pageTitle: 'Terminals',
        permissions: ['POS_SALE_TERMINALS_VIEW'],
        enablePreferences: true,
      },
    });
  }).name;
